import React from 'react'
import './Profile.css'

function Newsletter() {
  return (
    <div className='newsletter-container'>
      <h1 className='newsletter-description'>Nutrition Profile</h1>
      <h1>Coming soon.....</h1>
    </div>
  )
}

export default Newsletter
